import { css } from "lit"

export const baseStyles = css`
  :host {
    display: block;
    font-family:
      Avenir LT W01_45 Book1475508,
      Avenir,
      sans-serif;
    line-height: 1.8;
    font-weight: 400;
    font-size: 16px;
    color: rgb(16, 11, 0);
  }

  ::selection {
    background: #c8d7d1;
  }

  * {
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family:
      HCo Mercury Text G2,
      Times New Roman,
      serif;
    font-weight: 400;
    line-height: 1.3;
    margin: 0;
  }

  footer {
    background-color: #f7f7f7;
    width: 100%;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  a:hover {
    text-decoration: underline;
    text-underline-offset: 0.25rem;
    color: #859e3b;
  }
`
